import { createAction } from 'redux-actions';
import { Map as ImmutableMap } from 'immutable';

import { Dataset } from 'companion-app-components/flux/datasets/datasetsTypes';
import { rootUiActions, rootUiTypes } from 'companion-app-components/flux/root-ui';

export const DIALOG_TYPE_SHARE_FINANCES = 'SHARE_FINANCES_DIALOG';
export const DIALOG_TYPE_INVITE_SENT = 'INVITE_SENT_DIALOG';
export const DIALOG_TYPE_MANAGE_MEMBERS = 'MANAGE_MEMBERS_DIALOG';
export const DIALOG_TYPE_CONFIRMATION_NEW = 'CONFIRMATION_NEW_DIALOG';
export const DIALOG_TYPE_ACCOUNT_SHARE = 'ACCOUNT_SHARE_DIALOG';

export const showShareFinancesDialog = createAction(
  rootUiActions.createDialog.toString(),
  (props) => rootUiTypes.mkRootUiData({
    type: DIALOG_TYPE_SHARE_FINANCES,
    id: DIALOG_TYPE_SHARE_FINANCES,
    props: ImmutableMap(props),
  }),
);

export const showInviteSentDialog = createAction(
  rootUiActions.createDialog.toString(),
  (props) => rootUiTypes.mkRootUiData({
    type: DIALOG_TYPE_INVITE_SENT,
    id: DIALOG_TYPE_INVITE_SENT,
    props: ImmutableMap(props),
  }),
);

export const showManageMembersDialog = createAction(
  rootUiActions.createDialog.toString(),
  (props: { dataset: Dataset }) => rootUiTypes.mkRootUiData({
    type: DIALOG_TYPE_MANAGE_MEMBERS,
    id: DIALOG_TYPE_MANAGE_MEMBERS,
    props: ImmutableMap(props),
  }),
);

export const showConfirmationDialog = createAction(
  rootUiActions.createDialog.toString(),
  (props) => rootUiTypes.mkRootUiData({
    type: DIALOG_TYPE_CONFIRMATION_NEW,
    id: DIALOG_TYPE_CONFIRMATION_NEW,
    props: ImmutableMap(props),
  }),
);

export const showAccountShareDialog = createAction(
  rootUiActions.createDialog.toString(),
  (props) => rootUiTypes.mkRootUiData({
    type: DIALOG_TYPE_ACCOUNT_SHARE,
    id: DIALOG_TYPE_ACCOUNT_SHARE,
    props: ImmutableMap(props),
  }),
);
